module.exports = __webpack_public_path__ + "img/home-static-blog.6bf24770.jpeg";